import { Grid, Paper, Typography, Tab, Tabs, Box } from '@mui/material'
import PreviouslyAdded from './PreviouslyAdded'
import AddNewForm from './AddNewForm'
import Confirmation from 'Components/ReusableComponents.js/ConfirmationPopup/Confirmation'
import { useNavigate } from 'react-router-dom'

const LeaderboardTabContainer = ({
  selectedTab,
  setSelectedTab,
  editData,
  setEditData,
  promptOnTabChange,
  setPromptOnTabChange,
  showConfirmDialog,
  setShowConfirmDialog,
  pendingTabIndex,
  setPendingTabIndex,
}) => {
  let navigate = useNavigate()

  const handleTabClick = (tabIndex) => {
    if (editData && tabIndex === 0) {
      if (promptOnTabChange) {
        setPendingTabIndex(tabIndex)
        setShowConfirmDialog(true)
      } else {
        setEditData(null)
        setSelectedTab(tabIndex)
      }
    } else if (promptOnTabChange && tabIndex !== selectedTab) {
      setPendingTabIndex(tabIndex)
      setShowConfirmDialog(true)
    } else {
      if (tabIndex === 0 || tabIndex === 1) {
        setEditData(null)
      }
      setSelectedTab(tabIndex)
    }
  }

  const confirmTabSwitch = () => {
    setShowConfirmDialog(false)
    setPromptOnTabChange(false)

    if (pendingTabIndex === 'settings') {
      navigate('/Settings')
    } else if (pendingTabIndex === 0 || pendingTabIndex === 1) {
      setEditData(null)
      setSelectedTab(pendingTabIndex)
    } else {
      setSelectedTab(pendingTabIndex)
    }

    setPendingTabIndex(null)
  }

  return (
    <Grid md={12} lg={12} xl={12}>
      <Paper
        className="d-flex flex-column"
        sx={{
          pt: 3,
          pb: 3,
          pl: 4.5,
          pr: 4.5,
          mt: 4,
          ml: 1,
          width: '100%',
          borderRadius: 6,
          overflow: 'auto',
        }}
      >
        <Typography variant="h5" className="send-alert-heading">
          Leaderboard Tabs
        </Typography>
        <Tabs className="d-flex mt-4" indicatorColor="none">
          <Box
            onClick={() => handleTabClick(0)}
            className={`cursorshow py-2 px-3 mr-4 ${selectedTab === 0 ? 'tab-button-active' : 'tab-btns'}`}
          >
            Previously Added Tab
          </Box>

          <Box
            onClick={() => handleTabClick(1)}
            className={`cursorshow py-2 px-3 mr-4 ${selectedTab === 1 ? 'tab-button-active' : 'tab-btns'}`}
          >
            Add New Tab
          </Box>
        </Tabs>
        <hr className="w-100 mt-4" />

        <Box sx={{ mt: 3 }}>
          {selectedTab === 0 && !editData && (
            <PreviouslyAdded setSelectedTab={setSelectedTab} setEditData={setEditData} />
          )}
          {(selectedTab === 1 || editData) && (
            <AddNewForm
              editData={editData}
              setEditData={setEditData}
              setPromptOnTabChange={setPromptOnTabChange}
              setSelectedTab={setSelectedTab}
            />
          )}
        </Box>
      </Paper>
      {showConfirmDialog && (
        <Confirmation
          text="All entered data will be lost. Please confirm"
          affirm="Confirm"
          cancel="Cancel"
          affirmFunction={confirmTabSwitch}
          cancelFunction={() => setShowConfirmDialog(false)}
        />
      )}
    </Grid>
  )
}

export default LeaderboardTabContainer
